import { Typography, keyframes } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext, useState } from 'react'
import { Info } from '@mui/icons-material'
import ModalInfoImovel from './ModalInfoImovel'

const CardImovel = ({ imovel }) => {
    const { imovelSelecionado, mudaImovelSelecionado, activeCond } = useContext(VisitantesContext)

    const [openInfoImovel, setOpenInfoImovel] = useState(false)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'row',
            height: '75px',
            width: '120px',
            justifyContent: 'center',
            alignItems: 'center',
            // border: imovelSelecionado && imovel.id == imovelSelecionado.id ? '2px solid' : '',
            // borderColor: imovelSelecionado && imovel.id == imovelSelecionado.id ? '#45e045' : '',
            borderRadius: '5px',
            cursor: 'pointer',
            margin: '5px',
            backgroundColor: 'white',
            boxShadow: imovelSelecionado && imovel.id == imovelSelecionado.id
                ? '0px 2px 4px 1px rgba(69, 224, 69, 1)'
                : '0px 2px 4px 1px rgba(0, 0, 0, 0.322)'
        }}>
            {openInfoImovel &&
            <ModalInfoImovel
                imovel={imovel}
                open={openInfoImovel}
                setOpen={setOpenInfoImovel}
            />}
            <Grid sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '75px',
                width: '25px',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Info onClick={() => setOpenInfoImovel(true)} sx={{
                    ...IconSx,
                    color: imovel.observacao && imovel.observacao != ''
                        ? 'red'
                        : 'black',
                    animation: imovel.observacao && imovel.observacao != '' ? `${blinkAnimation} 1s 3` : 'none'
                }}
                />
            </Grid>
            <Grid onClick={() => {
            // buscarMoradorPorFiltro({ idImovel: imovel.id
                mudaImovelSelecionado(imovel)
            }} sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '75px',
                width: '95%',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Grid sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    boxSizing: 'border-box'
                }}>
                    <Typography sx={{
                        color: 'black',
                        fontSize: '10px',
                        textAlign: 'center'
                    }}>
                        {activeCond.tipo_imovel}
                    </Typography>
                    <Typography sx={{
                        color: 'black',
                        fontSize: '13px',
                        fontWeight: 700,
                        width: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'center'

                    }}>
                        {imovel.unidade1}
                    </Typography>
                </Grid>
                <Grid sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    boxSizing: 'border-box'
                }}>
                    <Typography sx={{
                        color: 'black',
                        fontSize: '10px',
                        textAlign: 'center'
                    }}>
                        {activeCond.desc_tipo_imovel}
                    </Typography>
                    <Typography sx={{
                        color: 'black',
                        fontSize: '13px',
                        fontWeight: 700,
                        width: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'center'

                    }}>
                        {imovel.unidade2}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardImovel

export const IconSx = {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',
    height: '20px',
    cursor: 'pointer'
}

const blinkAnimation = keyframes`
    0% {
        color: red;
    }
    33% {
        color: blue;
    }
    66% {
        color: red;
    }
    100% {
        color: red;
    }
`
